import { useTranslation } from "react-i18next";
import { BookOutlined } from "@ant-design/icons";

import styles from "./SelectHandbookPage.module.css";

/**
 * Сервис в сайдбаре выбран, а справочник ещё нет. Раньше на этом месте
 * показывался список всех сервисов, что сбивало с толку.
 */
export default function SelectHandbookPage() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.body}>
        <BookOutlined className={styles.icon} />

        <div className={styles.title}>
          {t("handbook.empty.title", "Справочник не выбран")}
        </div>

        <div className={styles.hint}>
          {t(
            "handbook.empty.hint",
            "Выберите справочник в меню слева, чтобы посмотреть и отредактировать его записи.",
          )}
        </div>
      </div>
    </div>
  );
}
